import type { DateTimeFieldProps } from "./FormFields.interface";

export default function DateTimeField({
  label,
  value,
  onChange,
  invalid,
}: DateTimeFieldProps) {
  return (
    <div className={`form-field ${invalid ? "invalid" : ""}`}>
      <label>{label}</label>
      <input
        type="datetime-local"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
